"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var SimpleDialog = _react.default.createClass({
  displayName: "SimpleDialog",
  propTypes: {
    className: _react.PropTypes.string,
    children: _react.PropTypes.element,
    confirmDisabled: _react.PropTypes.bool,
    contextual: _react.PropTypes.bool,
    headerText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
    onConfirm: _react.PropTypes.func.isRequired,
    onReject: _react.PropTypes.func.isRequired,
    primaryClass: _react.PropTypes.string,
    primaryText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]).isRequired,
    primaryUse: _react.PropTypes.string,
    secondaryClass: _react.PropTypes.string,
    secondaryText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
    secondaryUse: _react.PropTypes.string,
    size: _react.PropTypes.oneOf(['auto', 'medium', 'short', 'tall']),
    use: _react.PropTypes.string,
    width: _react.PropTypes.number
  },
  getDefaultProps: function getDefaultProps() {
    return {
      className: '',
      confirmDisabled: false,
      contextual: true,
      primaryClass: 'uiConfirm-button',
      primaryUse: 'primary',
      secondaryClass: 'uiConfirm-button',
      secondaryUse: 'secondary',
      width: 450
    };
  },
  handleConfirm: function handleConfirm() {
    this.props.onConfirm();
  },
  handleReject: function handleReject() {
    this.props.onReject();
  },
  renderHeader: function renderHeader() {
    var headerText = this.props.headerText;

    if (!headerText) {
      return null;
    }

    return _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement("h4", {
      className: "m-all-0"
    }, headerText));
  },
  renderSecondaryButton: function renderSecondaryButton() {
    var _this$props = this.props,
        secondaryClass = _this$props.secondaryClass,
        secondaryText = _this$props.secondaryText,
        secondaryUse = _this$props.secondaryUse;

    if (!secondaryText) {
      return null;
    }

    return _react.default.createElement(_UIButton.default, {
      className: secondaryClass,
      onClick: this.handleReject,
      use: secondaryUse
    }, secondaryText);
  },
  render: function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        children = _this$props2.children,
        confirmDisabled = _this$props2.confirmDisabled,
        primaryClass = _this$props2.primaryClass,
        primaryText = _this$props2.primaryText,
        primaryUse = _this$props2.primaryUse,
        size = _this$props2.size,
        use = _this$props2.use,
        width = _this$props2.width;
    return _react.default.createElement(_UIModal.default, {
      contextual: false,
      size: size,
      width: width,
      use: use,
      dialogClassName: className
    }, _react.default.createElement(_UIDialogCloseButton.default, {
      onClick: this.handleReject
    }), this.renderHeader(), _react.default.createElement(_UIDialogBody.default, null, children), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_UIButton.default, {
      className: primaryClass,
      disabled: confirmDisabled,
      onClick: this.handleConfirm,
      use: primaryUse
    }, primaryText), this.renderSecondaryButton()));
  }
});

var _default = SimpleDialog;
exports.default = _default;
module.exports = exports.default;